import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

/** Discovery and authenticated fetch only; response policy belongs to each domain. */
export class ApiTransport {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async request(path: string, init?: RequestInit): Promise<Response> {
    const baseUrl = await this.discoveryApi.getBaseUrl('spassu-code');
    const url = `${baseUrl}${path}`;
    return init === undefined
      ? this.fetchApi.fetch(url)
      : this.fetchApi.fetch(url, init);
  }
}
